import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Radio, withStyles } from "@material-ui/core";
import PaginadorApp from "app/Core/Components/Paginador/PaginadorApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import classNames from "classnames";
import { connect } from "react-redux";
import React from "react";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/EmpresaCentroCustoActions";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

class EmpresaCentroCustoList extends XAPPComponent {

    state = {
        selected: []
    };

    componentDidMount() {
        const { listFilter } = this.props;
        listFilter(null, "spvwempresacentrocusto");
    }

    componentDidUpdate() {
        if (this.props.CentroCusto.error) {
            this.props.showMessage({
                message: this.props.CentroCusto.error,
                variant: "error"
            });
            this.props.CentroCusto.error = null;
        }
    }

    handleChangeRadio = (event, item) => {
        var AState = this.state.selected;
        var AExists = false;
        if (this.isSelected(item.idpessoaformulario))
            AExists = true;

        if (!AExists) {
            var obj = item;
            obj["id"] = item.idpessoaformulario;
            obj["label"] = item.nome;
            if (!this.props.multiSelect)
                AState = [];
            AState.push(obj);
            this.setState(_.set({ ...this.state }, event.target.name, AState));
            this.props.onChange(AState);
        }
    };

    isSelected = (id) => {
        var AState = this.state.selected;
        var AExists = false;
        AState.forEach((item) => {
            if (item.idpessoaformulario === id || item.id === id)
                AExists = true;
        });
        return AExists;
    };

    getColumns = (_AisLookup) => {
        const { isLookup } = this.props;
        const { selected } = this.state;
        const Columns = [
            {
                Header: "",
                width: 60,
                Cell: row => (
                    <div className="flex items-center">
                        {isLookup && row.original.statusregistro === 1 && (
                            <Radio
                                name="selected"
                                checked={selected?.length > 0 && this.isSelected(row.original.idpessoaformulario)}
                                onClick={event => event.stopPropagation()}
                                onChange={event => this.handleChangeRadio(event, row.original)}
                            />
                        )}
                    </div>
                )
            },
            {
                Header: "Código",
                accessor: "codigo",
                className: ""
            },
            {
                Header: "Nome",
                accessor: "nome",
                className: ""
            }
        ];

        if (_AisLookup !== true) {
            Columns.splice(0, 1);
        }
        return Columns;
    };

    nextPage = () => {
        const { filter, xappRouteParams, CentroCusto } = this.props;
        if (CentroCusto.pagina < CentroCusto.data[0].paginas) {
            this.props.list("SELECIONAR", xappRouteParams, filter, CentroCusto.pagina + 1);
        }
    };

    render() {
        const { CentroCusto, openEditDialog, classes, isLookup } = this.props;

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    className={classNames(classes.root, "-striped -highlight border-0")}
                    getTrProps={(state, rowInfo) => {
                        return {
                            onClick: () => openEditDialog(rowInfo.original)
                        };
                    }}
                    data={CentroCusto.data ? CentroCusto.data : []}
                    columns={this.getColumns(isLookup)}
                    defaultPageSize={100}
                    noDataText="Não existem registros cadastrados!"
                    PaginationComponent={PaginadorApp}
                    nextPage={this.nextPage}
                    paginas={CentroCusto.data ? CentroCusto.data[0].paginas : 1}
                    pagina={CentroCusto.pagina}
                />
            </FuseAnimate>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        openNewDialog: Actions.openNewDialog,
        openEditDialog: Actions.openEditDialog,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ EmpresaCentroCusto }) {
    return {
        CentroCusto: EmpresaCentroCusto
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaCentroCustoList)));
